module.exports = __webpack_public_path__ + "static/img/lgss.2c35c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lgss.png
// module id = d+xj
// module chunks = 0